<template>
  <main :class="['page', { 'page--initial': !hasSearched }]">
    <section v-show="!hasSearched" class="logo-box">
      <div class="logo">
        <img :src="logoUrl" width="323" height="122" alt="DEKA">
        <p>DEKA产品官方验证查询</p>
      </div>
    </section>

    <form :class="['search-form', { 'search-form--result': hasSearched }]" @submit.prevent="handleSearch">
      <label class="form-item">
        <span>省份</span>
        <select v-model="selectedProvince" @change="syncCity">
          <option disabled value="">请选择省份</option>
          <option v-for="province in areas" :key="province.provinceCode" :value="province.provinceCode">
            {{ province.provinceName }}
          </option>
        </select>
      </label>

      <label class="form-item">
        <span>城市</span>
        <select v-model="selectedCity">
          <option disabled value="">请选择城市</option>
          <option v-for="city in currentCities" :key="city.cityCode" :value="city.cityCode">
            {{ city.cityName }}
          </option>
        </select>
      </label>

      <label class="form-item form-item--keyword">
        <span>搜索</span>
        <input v-model.trim="keyword" type="text" autocomplete="off" placeholder="输入机构关键字直接查询">
        <button class="search-button" type="submit" :disabled="loading" aria-label="搜索">
          <img :src="searchUrl" alt="">
        </button>
      </label>
    </form>

    <section v-show="hasSearched" class="result-box">
      <div class="result">
        <div class="result-title">
          您搜索的<span>“{{ searchedKeyword }}”</span>找到<i>{{ resultCount }}</i>个结果
        </div>

        <ul v-if="resultHtml" class="backend-results" v-html="resultHtml" @click="handleBackendResultClick"></ul>
        <ul v-else class="result-cards">
          <li v-for="(item, index) in normalizedResults" :key="item.id || index" :class="{ current: openedIndex === index }">
            <button type="button" class="result-head" @click="toggleResult(index)">
              <span>{{ item.name }}</span>
            </button>
            <div v-show="openedIndex === index" class="result-detail">
              <div class="detail-logo" v-if="resultImage(item)">
                <img :src="resultImage(item)" alt="">
              </div>
              <div class="detail-info">
                <p v-if="resultSn(item)" class="sn-line"><span>设备SN码:</span> {{ resultSn(item) }}</p>
                <p v-if="item.address"><span>地址:</span></p>
                <p v-if="item.address">{{ item.address }}</p>
                <p v-if="item.phone"><span>电话：</span>{{ item.phone }}</p>
                <p v-if="item.contact"><span>联系人：</span>{{ item.contact }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <footer class="footer">
      <p>
        DEKA中国区域官网：www.dekalaser-china.cn
        <a href="https://www.dekalaser-china.cn/">点击进入</a><br>
        邮箱：d.liang@deka.it
      </p>
    </footer>

    <div v-show="toast" class="tips-box">{{ toast }}</div>
  </main>
</template>

<script>
import searchUrl from './assets/sousuo.png'
import defaultProductUrl from './assets/onda-pro-result.png'
import { listCities, listProvinces, resolveImageUrl, searchDealers } from './api/dealer'
import { setupWechatShare } from './utils/wechatShare'

export default {
  name: 'App',
  data() {
    return {
      areas: [],
      logoUrl: `${process.env.BASE_URL}assets/logo.png`,
      searchUrl,
      defaultProductUrl,
      selectedProvince: '',
      selectedCity: '',
      keyword: '',
      searchedKeyword: '',
      hasSearched: false,
      loading: false,
      loadingAreas: false,
      resultHtml: '',
      resultCount: 0,
      normalizedResults: [],
      staticDealers: [
        {
          id: 'nanjing-qiaoshiguang',
          province: '12',
          city: '13',
          name: '南京翘时光生物科技有限公司',
          sn: 'M116N1-TU251818',
          address: '江苏省南京市江苏省南京市建邺区中和路68号(金陵天地)4层21商铺'
        },
        {
          id: 'jiangxi-manyan',
          province: '15',
          city: '16',
          name: '江西漫妍科技有限公司',
          sn: 'M116N1-TU251814',
          address: '江西省南昌市'
        }
      ],
      openedIndex: null,
      toast: ''
    }
  },
  computed: {
    currentProvince() {
      return this.areas.find(item => item.provinceCode === this.selectedProvince) || { mallCityList: [] }
    },
    currentCities() {
      return this.currentProvince ? this.currentProvince.mallCityList : []
    }
  },
  mounted() {
    setupWechatShare()
    this.loadProvinces()
  },
  beforeDestroy() {
    window.clearTimeout(this.toastTimer)
  },
  methods: {
    normalizeProvince(item) {
      return {
        provinceCode: item.id,
        provinceName: item.name || item.districtName || '',
        mallCityList: []
      }
    },
    normalizeCity(item) {
      return {
        cityCode: item.id,
        cityName: item.name || item.districtName || ''
      }
    },
    normalizeDealer(item) {
      return {
        id: item.id,
        name: item.title || item.name || '',
        sn: item.code || item.sn || '',
        address: item.content || item.address || '',
        imageUrl: resolveImageUrl(item.images || item.imageUrl || item.image)
      }
    },
    async loadProvinces() {
      this.loadingAreas = true

      try {
        const list = await listProvinces()
        this.areas = Array.isArray(list) ? list.map(this.normalizeProvince) : []
        this.selectedProvince = ''
        this.selectedCity = ''
      } catch (error) {
        this.showToast(error.message || '省份列表加载失败')
      } finally {
        this.loadingAreas = false
      }
    },
    async loadCities(provinceId, preferredCityName = '') {
      if (provinceId === '' || provinceId === null || typeof provinceId === 'undefined') {
        this.selectedCity = ''
        return
      }

      const province = this.areas.find(item => item.provinceCode === provinceId)
      if (!province) return

      try {
        const list = await listCities(provinceId)
        province.mallCityList = Array.isArray(list) ? list.map(this.normalizeCity) : []

        const defaultCity = province.mallCityList.find(item => preferredCityName && item.cityName.includes(preferredCityName)) || province.mallCityList[0]
        this.selectedCity = defaultCity ? defaultCity.cityCode : ''
      } catch (error) {
        province.mallCityList = []
        this.selectedCity = ''
        this.showToast(error.message || '城市列表加载失败')
      }
    },
    async syncCity() {
      await this.loadCities(this.selectedProvince)
    },
    async handleSearch() {
      this.loading = true
      this.resultHtml = ''
      this.normalizedResults = []

      const keyword = this.keyword.trim()
      if (!keyword) {
        this.loading = false
        this.showToast('输入机构关键字直接查询！')
        return
      }

      if (this.selectedProvince === '' || this.selectedCity === '') {
        this.loading = false
        this.showToast('请选择省份和城市')
        return
      }

      try {
        const list = await searchDealers({
          provinceId: this.selectedProvince,
          cityId: this.selectedCity,
          title: keyword
        })
        const results = Array.isArray(list) ? list.map(this.normalizeDealer) : []

        this.searchedKeyword = keyword
        this.hasSearched = true
        this.resultCount = results.length
        this.normalizedResults = results
        this.openedIndex = null

        if (results.length === 0) {
          this.showToast('未查询到相关信息')
        }
      } catch (error) {
        this.showToast(error.message || '查询失败，请稍后重试')
      } finally {
        this.loading = false
      }
      if (this.useStaticFallback) {

      const list = this.staticDealers.filter(item => {
        const areaMatched = item.province === this.selectedProvince && item.city === this.selectedCity
        const keywordMatched = Array.from(keyword).some(char => item.name.includes(char))
        return areaMatched && keywordMatched
      })

      this.searchedKeyword = keyword
      this.hasSearched = true
      this.resultCount = list.length
      this.normalizedResults = list
      this.openedIndex = null
      this.loading = false

      if (list.length === 0) {
        this.showToast('未查询到相关信息')
      }
      }
    },
    resultImage(item) {
      return item.imageUrl || item.image || item.productImage || item.productImageUrl || item.logo || this.defaultProductUrl
    },
    resultSn(item) {
      return item.sn || item.deviceSn || item.deviceSN || item.serialNo || item.serialNumber || ''
    },
    toggleResult(index) {
      this.openedIndex = this.openedIndex === index ? null : index
    },
    handleBackendResultClick(event) {
      const title = event.target.closest('h4')
      if (!title) return

      const item = title.closest('li')
      if (!item) return

      const isCurrent = item.classList.contains('current')
      const siblings = item.parentElement ? Array.from(item.parentElement.children) : []
      siblings.forEach(node => {
        node.classList.remove('current')
        const detail = node.querySelector('.resultLi')
        if (detail) detail.style.display = 'none'
      })

      if (!isCurrent) {
        item.classList.add('current')
        const detail = item.querySelector('.resultLi')
        if (detail) detail.style.display = 'block'
      }
    },
    showToast(message) {
      this.toast = message
      window.clearTimeout(this.toastTimer)
      this.toastTimer = window.setTimeout(() => {
        this.toast = ''
      }, 3000)
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

html,
body {
  min-height: 100%;
  margin: 0;
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
  background: #ffffff;
}

button,
input,
select,
textarea,
option,
optgroup {
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  outline: 0;
}

.page {
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
}

button {
  cursor: pointer;
}

.page {
  position: relative;
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  overflow-x: hidden;
  background-color: #fff;
  background-image: url("./assets/beijing-375.png");
  background-image: image-set(
    url("./assets/beijing-375.png") 1x,
    url("./assets/beijing.png") 2x
  );
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: min(100vw, 750px) auto;
  padding-bottom: 150px;
}

.page > * {
  position: relative;
  z-index: 1;
}

.page::before {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: none;
  content: "";
  background: rgba(0, 0, 0, 0.22);
  pointer-events: none;
}

.page--initial {
  padding-bottom: 130px;
}

.logo-box {
  width: 70%;
  margin: 0 auto;
  padding-top: 116px;
}

.logo {
  text-align: center;
  padding-bottom: 60px;
}

.logo img {
  display: inline-block;
  width: auto;
  max-width: 210px;
  height: auto;
  margin: 0 auto;
  border: none;
  vertical-align: middle;
}

.logo p {
  margin: 0;
  color: #1e1d42;
  font-size: 20px;
  line-height: 30px;
}

.search-form {
  width: 70%;
  margin: 0 auto;
}

.search-form--result {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 90%;
  padding-top: 50px;
}

.form-item {
  position: relative;
  display: block;
  width: 100%;
  margin-bottom: 30px;
}

.search-form--result .form-item {
  width: calc(50% - 5px);
}

.search-form--result .form-item--keyword {
  width: 100%;
}

.form-item span {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-size: 17px;
  line-height: 30px;
}

.form-item select,
.form-item input {
  display: block;
  width: 100%;
  height: 50px;
  border: 0;
  border-radius: 5px;
  outline: 0;
  background: #efefef;
  color: #999999;
  font-size: 16px;
  line-height: 50px;
  padding: 0 50px 0 15px;
  box-shadow: none;
}

.form-item select {
  appearance: none;
  background-image: url("../public/assets/xiala1.png");
  background-position: calc(100% - 15px) center;
  background-size: 16px 8px;
  background-repeat: no-repeat;
}

.form-item input::placeholder {
  color: #999999;
}

.form-item--keyword input {
  height: 50px;
  line-height: 50px;
  border-radius: 5px;
  background: #efefef;
  color: #999999;
  font-size: 16px;
  padding-left: 15px;
  padding-right: 50px;
}

.search-button {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 0 5px 5px 0;
  background: #1c0d44;
}

.search-button:disabled {
  opacity: 0.7;
}

.search-button img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.result-box {
  padding-top: 40px;
  padding-bottom: 50%;
  background: linear-gradient(180deg, rgba(26, 14, 64, 0.08), rgba(26, 14, 64, 0) 90px);
}

.result {
  width: 90%;
  margin: 0 auto;
}

.result-title {
  margin-bottom: 5px;
  color: #333;
  font-size: 16px;
  line-height: 30px;
}

.result-title span {
  color: #8373e5;
}

.result-title i {
  padding: 0 4px;
  font-style: normal;
}

.result ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.result li {
  margin-bottom: 10px;
  border-radius: 5px;
  overflow: hidden;
}

.result-head,
.backend-results li > h4 {
  display: flex;
  width: 100%;
  min-height: 50px;
  align-items: center;
  justify-content: flex-start;
  border: 0;
  border-radius: 5px;
  background: #1a0e40;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  line-height: 30px;
  padding: 10px 15px;
  text-align: left;
  cursor: pointer;
}

.backend-results li > h4 img {
  display: none;
}

.result-detail,
.backend-results .liBox {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background: #e8e6ec;
  padding: 20px 15px 18px;
}

.backend-results .resultLi {
  display: none;
}

.backend-results li.current .resultLi {
  display: block;
}

.detail-logo,
.backend-results .liL {
  flex: 0 0 220px;
  width: 220px;
  max-width: 35%;
}

.detail-logo img,
.backend-results .liL img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

.detail-info,
.backend-results .liR {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  padding-left: 16px;
}

.result-detail .detail-info:first-child {
  padding-left: 0;
}

.detail-info h4,
.backend-results .liR h4 {
  display: none;
}

.detail-info p,
.backend-results .liR p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 24px;
  word-break: break-all;
}

.detail-info p span,
.backend-results .liR p span {
  color: #333;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
}

.detail-info .sn-line,
.backend-results .liR p:first-child {
  color: #333;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 0;
}

.detail-info .sn-line span,
.backend-results .liR p:first-child span {
  font-weight: 700;
}

.footer {
  position: absolute;
  left: 0;
  bottom: 35px;
  width: 100%;
}

.footer p {
  width: 90%;
  margin: 0 auto;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.footer a {
  color: #8373e5;
  text-decoration: dashed;
}

.tips-box {
  position: fixed;
  top: 260px;
  left: 40%;
  z-index: 1001;
  width: 60%;
  height: auto;
  margin-left: -20%;
  padding: 15px 12px;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  line-height: 22px;
  text-align: center;
}

@media (max-width: 520px) {
  .logo-box,
  .search-form {
    width: 70%;
  }

  .search-form--result {
    width: 90%;
  }

  .search-form--result .form-item {
    width: 100%;
  }

  .logo-box {
    padding-top: 116px;
  }

  .logo img {
    max-width: 210px;
  }

  .page {
    background-size: max(100vw, 375px) auto;
  }

  .detail-logo,
  .backend-results .liL {
    flex-basis: 35%;
    width: 35%;
    max-width: 35%;
  }

  .detail-info,
  .backend-results .liR {
    width: 65%;
    padding-left: 15px;
  }
}

@media (min-width: 521px) {
  .page {
    background-image: url("./assets/beijing.png");
  }
}

@media (min-width: 521px) and (min-resolution: 1.5dppx) {
  .page {
    background-image: image-set(
      url("./assets/beijing.png") 1x,
      url("./assets/beijing.png") 2x
    );
  }
}

@media (min-width: 900px) {
  .page {
    max-width: none;
    min-height: 100vh;
    padding-bottom: 96px;
    background-color: #000;
    background-image: url("./assets/beijing.png");
    background-position: center calc(-50vw + 297px);
    background-size: 100vw auto;
  }

  .page::before {
    display: block;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0.06) 28%,
      rgba(255, 255, 255, 0) 56%
    );
  }

  .page--initial {
    padding-bottom: 96px;
  }

  .logo-box {
    display: flex;
    width: 70%;
    justify-content: center;
    padding-top: 116px;
  }

  .logo {
    padding-bottom: 60px;
  }

  .logo img {
    width: auto;
    max-width: 210px;
  }

  .logo p {
    color: #1e1d42;
    font-size: 20px;
    line-height: 30px;
  }

  .search-form {
    width: 500px;
  }

  .search-form--result {
    width: 640px;
    padding-top: 58px;
  }

  .form-item {
    margin-bottom: 30px;
  }

  .form-item span {
    margin-bottom: 5px;
    color: rgba(255, 255, 255, 0.78);
    font-size: 17px;
    line-height: 30px;
  }

  .form-item select,
  .form-item input {
    height: 50px;
    border-radius: 5px;
    color: #999999;
    font-size: 16px;
    line-height: 50px;
    padding-left: 15px;
    padding-right: 50px;
  }

  .form-item select {
    background-position: calc(100% - 15px) center;
    background-size: 16px 8px;
  }

  .search-button {
    width: 50px;
    height: 50px;
    border-radius: 0 5px 5px 0;
  }

  .search-button img {
    width: 24px;
    height: 24px;
  }

  .result-box {
    width: 700px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 120px;
    background: transparent;
  }

  .result {
    width: 100%;
  }

  .result-title {
    color: #fff;
  }

  .footer {
    bottom: 24px;
  }

  .footer p {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
  }
}

@media (min-width: 1600px) {
  .search-form {
    width: 500px;
  }

  .logo-box {
    width: 70%;
  }
}
</style>
